import EventSearchBar from './EventSearchBar';

export default EventSearchBar;
export type { EventSearchBarProps } from './EventSearchBar';
